module.exports = __webpack_public_path__ + "static/img/2.c630b8c5.jpg";